import axios from 'axios'
import dayjs from 'dayjs'
import config from '@/config/env'

const { API_URL } = config

const loadList = (params) => {
  return axios.get(`${API_URL}/insenterprise`, {
    params,
  })
}

const loadViewList = (params) => {
  return axios.get(`${API_URL}/insenterprise/view`, {
    params,
  })
}

const loadFrequentSigners = (params) => {
  return axios.get(`${API_URL}/stssigner/frequentsigners`, {
    params,
  })
}

const load = (identerprise) => {
  return axios.get(`${API_URL}/insenterprise/${identerprise}`)
}

const reevaluate = (identerprise) =>
  axios.get(API_URL + '/insenterprise/reevaluate', {
    params: { identerprise },
  })

const checkprogress = (identerprise) =>
  axios.get(API_URL + '/insenterprise/checkprogress', {
    params: { identerprise },
  })

const getpocketused = (identerprise) =>
  axios.get(API_URL + '/insenterprise/getpocketused', {
    params: { identerprise },
  })

const updatepocket = (enterprise) => axios.post(API_URL + '/insenterprise/updatepocket', enterprise)

const save = (enterpriseRequest) => {
  return axios.post(`${API_URL}/insenterprise`, enterpriseRequest)
}

const createFromIdentifier = (enterpriseRequest) => {
  return axios.post(`${API_URL}/insenterprise/createfromidentifier`, enterpriseRequest)
}

const ban = (enterprise) => {
  return axios.put(`${API_URL}/insenterprise/ban`, enterprise)
}

const reassignInsEnterprise = (identerprises, idagent) => {
  return axios.put(API_URL + '/insenterprise/reassign', null, {
    params: { identerprises, idagent },
  })
}

const reassignAllInsEnterprise = (identerprises, idcommercial, idoperator) => {
  return axios.put(API_URL + '/insenterprise/reassignall', null, {
    params: { identerprises, idcommercial, idoperator },
  })
}

const upLoadConfigFile = (tuple, reference, idfile, type, file) => {
  const formData = new FormData()
  formData.append('reference', reference)
  formData.append('tuple', tuple)
  formData.append('idfile', idfile)
  formData.append('type', type)
  formData.append('file', file)
  return axios.put(API_URL + `/insenterprise/fileconfig`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const update = (enterprise) => {
  const date = dayjs(enterprise.datestart).format('YYYY-MM-DD HH:mm:ss')
  return axios.put(API_URL + '/insenterprise', {
    ...enterprise,
    datestart: date,
  })
}

export const updateAdmins = (enterprise) => {
  return axios.post(API_URL + '/insenterprise/updateadmins', enterprise)
}

export const getUsers = (identerprise, query) => {
  return axios.get(API_URL + '/insenterprise/getusers', {
    params: { identerprise, query },
  })
}

const getEvaluationJSONInforma = (idprovisionalenterprise) => {
  return axios.get(API_URL + '/insenterprise/getevaluationjson', {
    params: {
      idprovisionalenterprise: idprovisionalenterprise,
    },
  })
}

const getEvaluationJSONAxesor = (idprovisionalenterprise) => {
  return axios.get(API_URL + '/insenterprise/getsecondevaluationjson', {
    params: {
      idprovisionalenterprise: idprovisionalenterprise,
    },
  })
}

export const api = {
  loadList,
  loadViewList,
  loadFrequentSigners,
  load,
  reevaluate,
  checkprogress,
  save,
  createFromIdentifier,
  ban,
  reassignInsEnterprise,
  reassignAllInsEnterprise,
  update,
  updateAdmins,
  getUsers,
  upLoadConfigFile,
  getEvaluationJSONInforma,
  getEvaluationJSONAxesor,
  getpocketused,
  updatepocket,
}

export default api
